module.exports = __webpack_public_path__ + "static/img/waistDrum_share.aa5a2b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/waistDrum_share.jpg
// module id = pHnh
// module chunks = 26